//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
export default {
    props: {
        show: Boolean
    },
    methods: {
        async chooseImg (source) {
            const paths = await WX_API.chooseImage({
                sourceType: [source],
                count: source === 'camera' ? 1 : 5,
                is_upload: true
            })
            if (this.is_peer_blocked) {
                this.showBlockToast()
                return
            }
            const promises_res = await Promise.allSettled(paths.map(item => WX_API.uploadImg(item)))
            promises_res.forEach(res => {
                const { status, value } = res
                if (status === 'fulfilled') {
                    this.$emit('chooseImg', value)
                }
            })
        }
    }
}
